import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useDashboardPermissions, DashboardPermissions } from '@/hooks/useDashboardPermissions';
import { toast } from 'sonner';

type Flag = keyof Omit<DashboardPermissions, 'reasons'>;

/**
 * Wraps a dashboard route element. If the current user lacks the required
 * permission flag, redirects to /dashboard with a toast.
 */
export function PermissionRoute({ flag, children }: { flag: Flag; children: ReactNode }) {
  const { permissions } = useDashboardPermissions();
  if (!permissions[flag]) {
    toast.error("You don't have permission to access that page.");
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
}
